// extracted by mini-css-extract-plugin
module.exports = {"card":"_2IZ4BCnm","noSpacing":"wY5dnp_C","isActive":"_30Pd0QIF"};